/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
// import * as auth from '../redux/AuthRedux'
// import {register} from '../redux/AuthCRUD'
import {Link, useHistory} from 'react-router-dom'
import {useLocation} from 'react-router'

import {toAbsoluteUrl} from '../../../../_metronic/helpers'

import './Registration.css'
import request from '../../api/request'
import toast, {Toaster} from 'react-hot-toast'
import FadeIn from 'react-fade-in'

const initialValues = {
  firstname: '',
  lastname: '',
  email: '',
  national_code: '',
  password: '',
  confirmPassword: '',
  mobile_number: '',
  introduce: '',
  acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'حداقل 3 کارکتر')
    .max(50, ' حداکثر 50 کارکتر')
    .required(' وارد کردن نام اجباری است'),
  email: Yup.string()
    .email('فرمت ایمیل صحیح نیست')
    .min(3, 'حداقل 3 کارکتر')
    .max(50, ' حداکثر 50 کارکتر')
    .required(' ایمیل اجباری است '),
  lastname: Yup.string()
    .min(3, 'حداقل 3 کارکتر')
    .max(50, ' حداکثر 50 کارکتر')
    .required(' وارد کردن نام خانوادگی اجباری است'),
  national_code: Yup.string()
    .required(' وارد کردن کد ملی اجباری است '),
  mobile_number: Yup.number()
    .required('تلفن ضروری است'),
  introduce: Yup.string().required('    یک مورد را انتخاب کنید '),
  password: Yup.string()
    .min(3, 'حداقل 3 کارکتر  ')
    .max(50, '  حداکثر 50 کارکتر ')
    .required('رمز عبور اجباری است   '),
  confirmPassword: Yup.string()
    .required('وارد کردن تکرار رمز عبور اجباری است.')
    .oneOf([Yup.ref('password'), null], 'پسورد مطابقت ندارد  '),
  acceptTerms: Yup.bool().oneOf([true]).required('شما باید قوانین شرکت سهامی ار تایید کنید '),
})

function useQuery() {
  const {search} = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

export function Registration() {
  const [selectOption, setSelectOption] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [RefralCode, setRefralCode] = useState<any>('')
  const dispatch = useDispatch()
  let history = useHistory()
  let query = useQuery()

  useEffect(() => {
    if (query.get('ref')) {
      setRefralCode(query.get('ref'))
    }
  }, [])

  console.log('myquery', RefralCode)

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      console.log(values)
      request
        .post('/register', {
          firstname: values.firstname,
          identifier_code: RefralCode,
          lastname: values.lastname,
          email: values.email,
          introduce: values.introduce,
          password: values.password,
          mobile_number: values.mobile_number,
          national_code: values.national_code,
        })
        .then((res) => {
          setLoading(false)
          toast.success(
            'حساب کاربری شما ایحاد شد تا چند ثانیه دیگر می توانید از طریق صفحه ورود وارد شوید !'
          )
          setTimeout(() => {
            history.push('/auth/login/?status=login')
          }, 2000)
        })
        .catch((err) => {
          toast.error(err.response.data.err)
          setLoading(false)
          console.log('err register', err.response.data)
        })
    },
    validateOnMount: true,
  })

  return (
    <div className={'w-lg-650px'}>
      <Toaster />
      <FadeIn>
        <form
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          noValidate
          id='kt_login_signup_form'
          onSubmit={formik.handleSubmit}
        >
          {/* begin::Heading */}
          <div className='mb-10 text-center'>
            {/* begin::Title */}
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='Metronic' />
              {/* <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div> */}
            </div>
            <h1 className='text-dark mb-3 mt-14 font-bold'> ایجاد حساب کاربری</h1>
            {/* end::Title */}
          </div>

          {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
          )}

          {/* begin::Form group Firstname */}
          <div className='row  fv-row mb-8 mt-18 rowCustom'>
            <div className='col-xl-6 customCol'>
              <label className='form-label fw-bolder flex justify-end'>نام خانوادگی</label>
              <input
                // {...formik.getFieldProps('email')}
                // name='firstname'
                dir={'rtl'}
                type='text'
                id='lastname'
                {...formik.getFieldProps('lastname')}
                name='lastname'
                // value={formik.values.lastname}
                // onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                placeholder='نام خانوادگی خود را وارد کنید'
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.lastname && formik.errors.lastname},
                  {
                    'is-valid': formik.touched.lastname && !formik.errors.lastname,
                  }
                )}
              />
              {/* email */}
              {formik.touched.lastname && formik.errors.lastname && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.lastname}</span>
                </div>
              )}
            </div>

            <div className='col-xl-6'>
              {/* begin::Form group Lastname */}
              <div className='fv-row mb-5'>
                <label className='form-label fw-bolder flex justify-end'>نام </label>
                <input
                  // {...formik.getFieldProps('email')}
                  // name='firstname'
                  dir={'rtl'}
                  type='text'
                  id='firstname'
                  {...formik.getFieldProps('firstname')}
                  name='firstname'
                  // onBlur={formik.handleBlur}
                  // value={formik.values.firstname}
                  // onChange={formik.handleChange}
                  placeholder='نام خود را وارد کنید'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.firstname && formik.errors.firstname},
                    {
                      'is-valid': formik.touched.firstname && !formik.errors.firstname,
                    }
                  )}
                />
                {/* email */}
                {formik.touched.firstname && formik.errors.firstname && (
                  <div className='fv-plugins-message-container'>
                    <span role='alert'>{formik.errors.firstname}</span>
                  </div>
                )}
              </div>
              {/* end::Form group */}
            </div>
          </div>
          {/* end::Form group */}

          {/* begin::Form group Email */}
          <div className='row fv-row mb-8 rowCustom'>
            <div className='col-xl-6 customCol '>
              <label className='form-label fw-bolder flex justify-end'>ایمیل </label>
              <input
                // {...formik.getFieldProps('email')}
                // name='firstname'
                dir={'rtl'}
                type='email'
                id='email'
                {...formik.getFieldProps('email')}
                name='email'
                // onBlur={formik.handleBlur}
                // value={formik.values.email}
                // onChange={formik.handleChange}
                placeholder=' ایمیل خود را وارد کنید'
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.email}</span>
                </div>
              )}
            </div>

            <div className='col-xl-6'>
              {/* begin::Form group Lastname */}
              {/* <div className='fv-row mb-5'> */}
              <div className='fv-row mb-5'>
                <label className='form-label fw-bolder flex justify-end'>کد ملی </label>
                <input
                  // {...formik.getFieldProps('email')}
                  // name='firstname'
                  dir={'rtl'}
                  type={'text'}
                  id='national_code'
                  {...formik.getFieldProps('national_code')}
                  name='national_code'
                  // onBlur={formik.handleBlur}
                  // value={formik.values.codemeli}
                  // onChange={formik.handleChange}
                  placeholder='کد ملی را وارد کنید'
                  className={clsx(
                    'form-control text-right form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.national_code && formik.errors.national_code},
                    {
                      'is-valid': formik.touched.national_code && !formik.errors.national_code,
                    }
                  )}
                />
                {formik.touched.national_code && formik.errors.national_code && (
                  <div className='fv-plugins-message-container'>
                    <span role='alert'>{formik.errors.national_code}</span>
                  </div>
                )}
              </div>

              {/* </div> */}
              {/* end::Form group */}
            </div>
          </div>
          {/* end::Form group */}

          <div className=' row fv-row mb-8 rowCustom' data-kt-password-meter='true'>
            <div className='col-xl-6 customCol '>
              <div className='fv-row mb-8'>
                <label className='form-label fw-bolder flex justify-end'>رمز عبور </label>
                <div className='position-relative mb-3'>
                  <input
                    // {...formik.getFieldProps('password')}
                    dir={'rtl'}
                    type='password'
                    id='password'
                    {...formik.getFieldProps('password')}
                    name='password'
                    // value={formik.values.password}
                    // onChange={formik.handleChange}
                    // onBlur={formik.handleBlur}
                    autoComplete='off'
                    placeholder=' رمز عبور خود را وارد کنید'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.password && formik.errors.password,
                      },
                      {
                        'is-valid': formik.touched.password && !formik.errors.password,
                      }
                    )}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.password}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='col-xl-6 mb-1'>
              <label className='form-label fw-bolder flex justify-end'> شماره تلفن همراه</label>
              <input
                dir={'rtl'}
                type='text'
                id='mobile_number'
                {...formik.getFieldProps('mobile_number')}
                name='mobile_number'
                // onBlur={formik.handleBlur}
                // value={formik.values.mobile_number}
                // onChange={formik.handleChange}
                autoComplete='off'
                placeholder='شماره تلفن همراه خود را وارد کنید'
                className={clsx(
                  'form-control text-right form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.mobile_number && formik.errors.mobile_number,
                  },
                  {
                    'is-valid': formik.touched.mobile_number && !formik.errors.mobile_number,
                  }
                )}
              />
              {formik.touched.mobile_number && formik.errors.mobile_number && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.mobile_number}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* begin::Form group Password */}
          <div className=' row fv-row mb-8 rowCustom' data-kt-password-meter='true'>
            <div className='col-xl-6 customCol '>
              <div className='selected'>
                <label className='form-label fw-bolder flex justify-end'>
                  نحوه آشنایی با خرید سهام بیمارستان
                </label>

                <select
                  dir={'rtl'}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  name='introduce'
                  className='introduce w-full appearance-none'
                >
                  <option selected disabled>
                    انتخاب کنید..
                  </option>
                  <option value='سایت بیمارستان'>سایت بیمارستان</option>
                  <option value='معرفی سهامداران'> معرفی سهامداران</option>
                  <option value='تبلیغات'>تبلیغات</option>
                  <option value='کارشناسان فروش'>کارشناسان فروش</option>
                </select>
                {formik.touched.introduce && formik.errors.introduce && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.introduce}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='col-xl-6'>
              <label className='form-label fw-bolder flex justify-end'>تکرار رمز عبور</label>
              <input
                // {...formik.getFieldProps('changepassword')}
                dir={'rtl'}
                type='password'
                id='confirmPassword'
                {...formik.getFieldProps('confirmPassword')}
                name='confirmPassword'
                // onBlur={formik.handleBlur}
                // value={formik.values.confirmPassword}
                // onChange={formik.handleChange}
                autoComplete='off'
                placeholder='  تکرار رمز عبور خود را  وارد کنید '
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.confirmPassword && formik.errors.confirmPassword,
                  },
                  {
                    'is-valid': formik.touched.confirmPassword && !formik.errors.confirmPassword,
                  }
                )}
              />
              {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.confirmPassword}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* end::Form group */}
          <div className='col-xl-12 mb-1'>
            <label className='form-label fw-bolder flex justify-end'> کد معرف</label>
            <input
              // {...formik.getFieldProps('changepassword')}
              dir={'rtl'}
              type='text  '
              defaultValue={RefralCode}
              className={'form-control text-right form-control-lg form-control-solid'}
              // onBlur={formik.handleBlur}
              // value={formik.values.mobile_number}
              onChange={(e) => setRefralCode(e.target.value)}
              autoComplete='off'
              placeholder='  در صورتی که کد معرف دارید آن را وارد کنید   '
            />

          </div>

          {/* begin::Form group Confirm password */}

          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='fv-row mt-12 mb-14  flex justify-end accept'>
            <div className='form-check form-check-custom form-check-solid  flex items-start	accept1'>
              <label
                className='form-check-label fw-bold text-gray-700 fs-6 flex flex-row-reverse'
                htmlFor='kt_login_toc_agree'
              >
                <Link to='/auth/terms' className='ms-1 link-primary'>
                  قوانین شرکت سهامی
                </Link>
                <p>را مطالعه کرده و قبول میکنم</p>
              </label>
              {formik.touched.acceptTerms && formik.errors.acceptTerms && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.acceptTerms}</span>
                  </div>
                </div>
              )}
              <input
                className='form-check-input'
                type='checkbox'
                checked={formik.values.acceptTerms}
                id='kt_login_toc_agree'
                {...formik.getFieldProps('acceptTerms')}
                name='acceptTerms'
              />
            </div>
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='row fv-row text-center'>
            <div className='col-xl-4 '>
              <Link to='/auth/login'>
                <button
                  type='button'
                  id='kt_login_signup_form_cancel_button'
                  className='btn btn-lg btn-light-primary w-100 mb-5 rounded-pill cursor-pointer'
                >
                  ورود
                </button>
              </Link>
            </div>
            <div className='col-xl-8  '>
              <button
                type='submit'
                id='kt_sign_up_submit'
                className={`btn btn-lg w-100 text-white rounded-pill mb-5 cursor-pointer ${
                  formik.isValid ? 'bg-teal' : 'bg-teal'
                }`}
                // disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
                disabled={!formik.isValid}
              >
                {!loading && <span className='indicator-label'>ثبت نام</span>}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    در حال بررسی{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
          {/* end::Form group */}
        </form>
      </FadeIn>
    </div>
  )
}
